import React, { useEffect, useState } from "react";
import { Box, Link, Stack, Typography } from "@mui/material";

import { API } from "../constant/apiConstant";
import { Colors } from "../utils/colors";

const footerDefaults = {
  poweredByText: "Product of Flip Games Limited"
};

export default function AdminFooter() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const response = await fetch(`${API.BASE_URL}/api/settings`);
        const data = await response.json();

        if (data?.status) {
          setSettings(data.settings || null);
        }
      } catch (error) {
        console.log(error);
      }
    };

    loadSettings();
  }, []);

  const socialLinks = [
    { label: "Facebook", url: settings?.facebook_url },
    { label: "Instagram", url: settings?.instagram_url }
  ].filter((link) => Boolean(link.url));

  return (
    <Box
      component="footer"
      sx={{
        mt: 4,
        px: { xs: 2, sm: 3, lg: 4 },
        py: 2,
        borderTop: "1px solid rgba(255,255,255,0.08)",
        bgcolor: "#06395d",
        color: "#fff"
      }}
    >
      <Stack spacing={1} alignItems="center" sx={{ width: "100%", maxWidth: "min(1600px, 100%)", mx: "auto" }}>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.78)", textAlign: "center" }}>
          {settings?.footer_powered_by_text || footerDefaults.poweredByText}
        </Typography>

        {socialLinks.length > 0 ? (
          <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center" useFlexGap>
            {socialLinks.map((link) => (
              <Link
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noreferrer"
                underline="hover"
                sx={{ color: Colors.accent, fontWeight: 700 }}
              >
                {link.label}
              </Link>
            ))}
          </Stack>
        ) : null}
      </Stack>
    </Box>
  );
}
